<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.pr-8.shrink
      div.sticky.white(style="width: 230px; top: 106px;")
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Registration settings
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/consultation-settings')") Consultation settings
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/checkout-settings')") Checkout settings

    v-col.grow
      v-container.pt-10
        v-breadcrumbs.pt-0.px-0.pb-3(:items="breadcrumbItems")
          template(v-slot:item="{ item }")
            a.text-sm.font-medium.no-underline.neutral700--text(v-if="!item.disabled" @click="$router.push(item.href)") {{ item.text }}
            .text-sm.neutral700--text(v-else) {{ item.text }}

        .text-2xl.font-semibold.neutral700--text Registration settings
        v-divider.mt-2
        .text-lg.font-medium.neutral700--text.mt-4 Configure required patient details
        .text-sm.neutral700--text This settings determine the required patient details in new registration

        .text-md.font-medium.neutral700--text.mt-4 Choose which details is required in patient registration
        div.d-flex.justify-center.mt-16(v-if="isFetching")
          v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          y-checkbox.mt-3(v-model="checked" disabled)
            template(#label)
              .neutral700--text.ml-2 Name
                span.text-xs.neutral500--text.ml-3 Required by system
          y-checkbox.mt-2(v-model="checked" disabled)
            template(#label)
              .neutral700--text.ml-2 Phone number
                span.text-xs.neutral500--text.ml-3 Required by system
          template(v-for="field in fields")
            y-checkbox.mt-2(v-model="field.required" :disabled="checkDisabled(field)")
              template(#label)
                .neutral700--text.ml-2 {{ field.name }}
                  span.text-xs.neutral500--text.ml-3(v-if="checkDisabled(field)") Required by system

        div.mt-4.mb-10
          .text-md.font-medium {{ $t('clear_queue')}}
          .text-sm.font-normal.neutral700--text {{ $t('clear_queue_description')}}
          div.mt-3(style="width: 300px;")
            v-text-field.round-xl(v-model="clearQueueAt" outlined placeholder="12:30 am" hide-details="auto" :loading="isFetchingQueue" dense height=48 type="time" :class="{ 'neutral300': clearQueueDisabled }" :disabled="clearQueueDisabled")
          yc-checkbox.mt-3(v-model="clearQueueDisabled")
            template(v-slot:label)
              .text-sm.ml-2 {{ $t('clear_queue_checkbox_description')}}

        v-footer.white(v-if="!isFetching" app inset padless elevation="3")
          v-container.px-8.py-2
            div.d-flex.align-center
              v-spacer
              y-button(:label="$t('save')" color="neutral700" dark :loading="isLoading" @click="saveData")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RegistrationSettings',
  data() {
    return {
      isFetching: false,
      isFetchingQueue: false,
      isLoading: false,
      checked: true,
      clearQueueDisabled: false,
      clearQueueAt: '08:00',
      fields: null,
      breadcrumbItems: [
        {
          text: 'Clinic management',
          disabled: false,
          href: '/admin/clinic/settings'
        },
        {
          text: 'Registration settings',
          disabled: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({ 
      company: 'getCompany',
      clinic: 'clinic/getClinic'
    }),
    defaultIC () {
      if (this.clinic && this.clinic.customer_uid_type === 'ic') {
        return true
      }
      return false
    }
  },
  mounted () {
    this.fetchFields()
    this.fetchSettings()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchFields () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/registrations/form`)
        .then(resp => {
          this.fields = resp.data.extra_fields
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchSettings () {
      this.isFetchingQueue = true
      this.$axios.get(`/clinics/${this.company.slug}/registrations/queue_settings`)
        .then(({ data }) => {
          if (data.clear_queue_at) {
            this.clearQueueAt = data.clear_queue_at
            this.clearQueueDisabled = false
          } else {
            this.clearQueueDisabled = true
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingQueue = false
        })
    },
    async saveData () {
      try {
        await this.$axios.patch(`/clinics/${this.company.slug}/registrations/form`, { extra_fields: this.fields })
        let data = {}
        if (!this.clearQueueDisabled) {
          if (this.clearQueueAt) {
            data.clear_queue_at =  this.clearQueueAt
          }
        } else {
          data.clear_queue_at = null
        }
        await this.$axios.patch(`/clinics/${this.company.slug}/registrations/queue_settings`, data)
        this.showMessage(['success', this.$t('success_message.update_successful')])
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
      }
    },
    checkDisabled (field) {
      if (field.field === 'ic') {
        if (this.defaultIC) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>